<template>
  <b-row>
    <b-col
      cols="12"
      class="pb-1 d-flex justify-content-end"
    >
      <b-button @click="showModal()">
        <feather-icon
          icon="PlusIcon"
          class="cursor-pointer"
        />
        <span>Add a task</span>
      </b-button>
    </b-col>
    <b-col
      cols="12"
      md="3"
      @dragover.prevent
      @drop="onDrop('Pending')"
    >
      <CardTask
        :card-title="{text: 'Pending' , color: '#212121'}"
        :status-data="PendingData"
        @dragstart="onDragStart"
      />
    </b-col>
    <b-col
      cols="12"
      md="3"
      @dragover.prevent
      @drop="onDrop('In Progress')"
    >
      <CardTask
        :card-title="{text: 'In Progress' , color: '#212121'}"
        :status-data="InProgressData"
        @dragstart="onDragStart"
      />

    </b-col>
    <b-col
      cols="12"
      md="3"
      @dragover.prevent
      @drop="onDrop('Completed')"
    >
      <CardTask
        :card-title="{text: 'Completed' , color: '#212121'}"
        :status-data="CompletedData"
        @dragstart="onDragStart"
      />
    </b-col>
    <b-col
      cols="12"
      md="3"
      @dragover.prevent
      @drop="onDrop('Cancelled')"
    >
      <CardTask
        :card-title="{text: 'Cancelled' , color: '#212121'}"
        :status-data="CancelledData"
        @dragstart="onDragStart"
      />
    </b-col>

    <b-modal
      v-model="isActionModalVisible"
      hide-footer
      hide-header
      size="lg"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <b-row>
        <div class="d-flex justify-content-between align-items-center bg-light w-100 px-2 mb-1">
          <span class="font-weight-bold text-lg py-1">Add Task</span>
          <feather-icon
            icon="XIcon"
            color="black"
            class="cursor-pointer"
            @click="closeModal()"
          />
        </div>
      </b-row>
      <AddEditTask @close-modal="closeModal" />
    </b-modal>

  </b-row>
</template>

<script>
import axios from 'axios'
import decryptData from '@/store/auth/decryptData'
import CardTask from './components-task-mamagement/CardTask.vue'
import AddEditTask from './components-task-mamagement/AddEditTask.vue'

export default {
  name: 'TaskManagments',
  components: {
    CardTask,
    AddEditTask,
  },
  data() {
    return {
      targetData: {
        item: null,
        label: null,
      },
      isActionModalVisible: false,
    }
  },
  computed: {
    PendingData() {
      return this.$store.getters['generalData/allTaskManagments/pendingData']
    },
    CompletedData() {
      return this.$store.getters['generalData/allTaskManagments/completedData']
    },
    CancelledData() {
      return this.$store.getters['generalData/allTaskManagments/cancelledData']
    },
    InProgressData() {
      return this.$store.getters['generalData/allTaskManagments/inProgressData']
    },
    taskLoadedFromStore() {
      return this.$store.getters['generalData/allTaskManagments/taskLoaded']
    },

  },
  watch: {

    // Watch for changes in taskLoaded
    taskLoadedFromStore(newVal) {
      if (!newVal) this.checkAndFetchTasks()
    },
  },
  async mounted() {
    await this.checkAndFetchTasks()
  },
  methods: {
    showModal() {
      this.isActionModalVisible = true
    },
    closeModal() {
      this.isActionModalVisible = false
    },
    async checkAndFetchTasks() {
      if (!this.taskLoadedFromStore) {
        await this.$store.dispatch('generalData/allTaskManagments/fetchTasks')
      }
    },
    onDragStart(event, label) {
      this.targetData.item = event
      this.targetData.label = label
    },
    getArrayNameByLabel(label) {
      switch (label) {
        case 'Pending': return 'PendingData'
        case 'Completed': return 'CompletedData'
        case 'Cancelled': return 'CancelledData'
        case 'In Progress': return 'InProgressData'
        default: return ''
      }
    },
    async onDrop(targetKey) {
      if (this.targetData.item === null || this.targetData.label === null || targetKey === this.targetData.label) return

      const task = this.targetData.item
      const sourceArrayName = this.getArrayNameByLabel(this.targetData.label)
      const targetArrayName = this.getArrayNameByLabel(targetKey)

      const sourceArray = this[sourceArrayName]
      const targetArray = this[targetArrayName]

      // Optimistic UI Update
      const itemIndex = sourceArray.findIndex(item => item.issue === task.issue)
      if (itemIndex === -1) return

      // Remove from source and push to target immediately
      sourceArray.splice(itemIndex, 1)
      targetArray.push(task)

      // Map the UI label to the API status
      const statusMap = {
        Pending: 'pending',
        'In Progress': 'in-progress',
        Completed: 'completed',
        Cancelled: 'canceled',
      }

      const newStatus = statusMap[targetKey]
      if (!newStatus) return

      try {
        // Call the API to update task status
        if (newStatus === 'canceled') {
          await axios.put(`https://gulftic-system.fci.group/api/task/created/${task.id}/cancel`)
        } else {
          await axios.put(`https://gulftic-system.fci.group/api/task/${task.id}/status`, {
            status: newStatus,
          })
        }
      } catch (error) {
        const revertedIndex = targetArray.findIndex(item => item.issue === task.issue)
        if (revertedIndex > -1) {
          targetArray.splice(revertedIndex, 1)
          sourceArray.splice(itemIndex, 0, task)
        }

        if (error.response.status === 403) {
          this.$toast.error('You don’t have permission to move this task to the Cancelled status.')
        } else {
          const payload = decryptData(error.response.data.payload)

          const firstArrayKey = Object.keys(payload).find(key => Array.isArray(payload[key]))
          const errorMessage = firstArrayKey ? payload[firstArrayKey][0] : 'An unknown error occurred'
          this.$toast.error(errorMessage)
        }
      } finally {
        // Always reset target data
        this.targetData.item = null
        this.targetData.label = null
      }
    },

  },
}
</script>
